import { motion } from "framer-motion";
import { EASE } from "@/components/site/motion";

export const ClipFrame = ({ src, alt = "", className = "", imgClass = "", caption, children }) => (
  <motion.figure
    initial="hide"
    whileInView="show"
    viewport={{ once: true, amount: 0.15 }}
    className={`relative ${className}`}
  >
    <motion.div
      variants={{
        hide: { clipPath: "inset(10% 10% 10% 10% round 18px)" },
        show: { clipPath: "inset(0% 0% 0% 0% round 18px)", transition: { duration: 1.4, ease: EASE } },
      }}
      className="relative h-full w-full overflow-hidden rounded-[18px] bg-ink-3"
    >
      <motion.img
        variants={{ hide: { scale: 1.18 }, show: { scale: 1, transition: { duration: 1.8, ease: EASE } } }}
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover ${imgClass}`}
      />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(120%_90%_at_35%_25%,transparent_20%,rgba(7,10,15,0.7)_80%)]" />
      {children}
    </motion.div>
    {caption && <figcaption className="eyebrow mt-3 text-fg-3">{caption}</figcaption>}
  </motion.figure>
);

export const SpotCard = ({ className = "", children, testId, as: Tag = "div", ...rest }) => {
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <Tag onMouseMove={onMove} className={`group relative overflow-hidden rounded-2xl border border-white/[0.08] bg-ink-2 ${className}`} data-testid={testId} {...rest}>
      <div className="spotlight pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      <div className="relative h-full">{children}</div>
    </Tag>
  );
};
